import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { contentTypesKeys } from '../../queryKeys/contentTypes';

export function useGetCtsWithCreatePermission(indexId?: number): UseQueryResult<string[], unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getCtsWithCreatePermission = () => {
    if (servicesCtx?.contentTypesService && indexId !== undefined) {
      return servicesCtx.contentTypesService.getCtsWithCreatePermission(indexId);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: contentTypesKeys.allWithCreatePermission(indexId),
    queryFn: getCtsWithCreatePermission,
    retry: 0,
    staleTime: 180000,
    gcTime: 180000,
    enabled: indexId !== undefined
  });
}
